import React, { useEffect, useState } from 'react';
import { jsPDF } from 'jspdf';
import PayrollLayout from '../../layouts/PayrollLayout';

export default function PayslipGeneration() {
  const [slips, setSlips] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const dummyData = [
        {
          id: 'EMP001',
          name: 'John Doe',
          gross: 50000,
          deductions: 10000,
          net: 40000,
          taxSummary: 5000,
          bankDetails: 'Bank of XYZ, Account No: 123456789',
          download_url: '/dummy-download-link',
        },
        {
          id: 'EMP002',
          name: 'Jane Smith',
          gross: 55000,
          deductions: 12000,
          net: 43000,
          taxSummary: 6000,
          bankDetails: 'ABC Bank, Account No: 987654321',
          download_url: '/dummy-download-link',
        },
        {
          id: 'EMP003',
          name: 'Michael Johnson',
          gross: 60000,
          deductions: 15000,
          net: 45000,
          taxSummary: 7000,
          bankDetails: 'XYZ Bank, Account No: 112233445',
          download_url: '/dummy-download-link',
        },
      ];
      setSlips(dummyData);
      setLoading(false);
    }, 1000);
  }, []);

  const generatePayslipPDF = (employee) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Payslip for ${employee.name}`, 10, 10);
    doc.setFontSize(12);
    doc.text(`Employee ID: ${employee.id}`, 10, 20);
    doc.text(`Gross Salary: ₹${employee.gross}`, 10, 30);
    doc.text(`Deductions: ₹${employee.deductions}`, 10, 40);
    doc.text(`Net Salary: ₹${employee.net}`, 10, 50);
    doc.text(`Tax Summary: ₹${employee.taxSummary}`, 10, 60);
    doc.text(`Bank Details: ${employee.bankDetails}`, 10, 70);
    doc.save(`${employee.name}_payslip.pdf`);
  };


  const filteredSlips = slips.filter((s) =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.id.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <PayrollLayout title="Payslip Generation">

      <div className="bg-white dark:bg-gray-900 font-poppins py-4 px-3 rounded-xl md:mx-0 mx-2 mb-2">
        <input
          type="text"
          placeholder="Search by name or ID..."
          className="w-full md:w-1/3 p-2 border dark:bg-black dark:border-gray-700 dark:text-white dark:focus:outline-none rounded shadow-sm text-sm"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg mx-2 font-poppins">
        <table className="min-w-full table-auto md:table-fixed text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
            <tr>
              <th  className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Employee ID</th>
              <th  className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Name</th>
              <th  className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Gross</th>
              <th  className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Deductions</th>
              <th  className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Net</th>
              <th  className="py-2 px-4 dark:text-white text-center font-semibold text-xs md:text-sm text-black whitespace-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
          {loading ? (
              <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                  <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                  {/* <p className="text-sm text-center text-gray-500">Loading reports...</p> */}
                </td>
              </tr>
            ) : filteredSlips.length === 0 ? (
              <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">No reports found</td>
              </tr>
            ) : (
              filteredSlips.map((s) => (
                <tr key={s.id} className="border-b dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-950 dark:hover:text-white">
                  <td className="py-2 dark:text-white px-4 text-xs md:text-sm whitespace-nowrap">{s.id}</td>
                  <td className="py-2 dark:text-white px-4 text-xs md:text-sm whitespace-nowrap">{s.name}</td>
                  <td className="py-2 dark:text-white px-4 text-xs md:text-sm whitespace-nowrap">₹{s.gross}</td>
                  <td className="py-2 dark:text-white px-4 text-xs md:text-sm whitespace-nowrap">₹{s.deductions}</td>
                  <td className="py-2 dark:text-white px-4 text-xs md:text-sm whitespace-nowrap">₹{s.net}</td>
                  <td className="py-2 px-4 flex items-center justify-center gap-2 text-xs md:text-sm whitespace-nowrap">
                    <button
                      onClick={() => generatePayslipPDF(s)}
                      className="text-blue-600 hover:underline"
                    >
                      Preview
                    </button>
                    <a
                      // href={s.download_url}
                      // target="_blank"
                      // rel="noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </PayrollLayout>
  );
}
